import { render, staticRenderFns } from "./ProductosData.vue?vue&type=template&id=61879c00&"
import script from "./ProductosData.vue?vue&type=script&lang=js&"
export * from "./ProductosData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports